<template>
    <div class="foot-panel bg-secondary">
        <div class="col-left">

            <p class="text-secondary">
                {{ lang($t("Selected")) }}
                <span class="text-primary txt-bold" :style="total_file_style">{{ resource_total_select }}</span> / 200
                {{ lang($t("files")) }}, {{ lang($t("Size")) }}
                <span class="text-primary txt-bold" :style="total_size_style">{{ resource_total_size }}</span> / 500 MB</p>
<!--            <a href="javascript:void(0);" class="action-btn h32" @click="addToInventory" :class="add_to_inventory_style">-->
<!--                <div>-->
<!--                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">-->
<!--                        <path d="M34,34 L16,34 L16,46 L34,46 L34,64 L46,64 L46,46 L64,46 L64,34 L46,34 L46,16 L34,16 L34,34 Z M74.6368338,19.9214656 C78.2122171,26.0495195 80.0001824,32.7427292 80,40 C80,47.2565411 78.2122171,53.9493859 74.6361041,60.0781695 C71.0594438,66.2062235 66.20762,71.0594846 60.0793557,74.6353989 C53.9507265,78.2118604 47.2574863,80 40.0005473,80 C32.7436082,80 26.0510978,78.2118604 19.9221037,74.6353989 C13.7934746,71.0582076 8.94146835,66.2062235 5.36462561,60.0781695 C1.78851258,53.9488386 0,47.256906 0,40 C0,32.7434589 1.7879653,26.0504317 5.3651729,19.9214656 C8.94219806,13.7928644 13.7942043,8.9408803 19.9228335,5.36460115 C26.0510978,1.78795715 32.7441555,0 40.001277,0 C47.2591282,0 53.9501792,1.78795715 60.0795381,5.36460115 C66.2078024,8.94142757 71.0598086,13.7934117 74.6368338,19.9214656 Z"></path>-->
<!--                    </svg>-->
<!--                </div>-->
<!--                <p>{{ lang($t("Add")) }}</p>-->
<!--            </a>-->

        </div>
        <div v-if="show_batch_btn_goodnotes" class="icon_goodnotes" style="margin-right: 12px" @click="addToPendingShareGoodNotes()">
<!--            <div>-->
<!--                <svg width="80px" height="80px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path clip-rule="evenodd" d="M21 10C23.4844 10 25.5 7.98535 25.5 5.5C25.5 4.53711 25.1973 3.64453 24.6816 2.91309C24.6172 2.82031 24.5488 2.73047 24.4766 2.64258L24.3672 2.51465C24.2324 2.36328 24.0879 2.2207 23.9336 2.08887C23.1465 1.41016 22.1211 1 21 1C18.5156 1 16.5 3.01465 16.5 5.5C16.5 6.09766 16.6172 6.66895 16.8281 7.19141L10.5938 10.791C9.77148 9.70312 8.46875 9 7 9C4.51562 9 2.5 11.0146 2.5 13.5C2.5 15.9854 4.51562 18 7 18C8.04492 18 9.00781 17.6436 9.77148 17.0449L16.7344 21.0645C16.582 21.5156 16.5 21.998 16.5 22.5C16.5 24.9854 18.5156 27 21 27C23.4844 27 25.5 24.9854 25.5 22.5C25.5 20.0146 23.4844 18 21 18C19.7383 18 18.5977 18.5205 17.7793 19.3584L11.0469 15.4707C11.3379 14.876 11.5 14.207 11.5 13.5C11.5 13.2012 11.4707 12.9092 11.416 12.627L17.9805 8.83594C18.7793 9.55957 19.8379 10 21 10ZM21 8C22.3809 8 23.5 6.88086 23.5 5.5C23.5 4.11914 22.3809 3 21 3C20.0352 3 19.1973 3.54688 18.7812 4.34863C18.6016 4.69336 18.5 5.08496 18.5 5.5C18.5 6.88086 19.6191 8 21 8ZM7 11C7.83984 11 8.58203 11.4131 9.03516 12.0479C9.12891 12.1787 9.21094 12.3193 9.27734 12.4678C9.41992 12.7822 9.5 13.1318 9.5 13.5C9.5 14.8809 8.38086 16 7 16C5.61914 16 4.5 14.8809 4.5 13.5C4.5 12.1191 5.61914 11 7 11ZM23.5 22.5C23.5 23.8809 22.3809 25 21 25C19.6191 25 18.5 23.8809 18.5 22.5C18.5 21.1191 19.6191 20 21 20C22.3809 20 23.5 21.1191 23.5 22.5Z" fill="#000000" fill-rule="evenodd"/>-->
<!--                </svg>-->
<!--            </div>-->
<!--            <p class="text-primary" :style="download_btn_style">{{ lang($t("Sync to Goodnotes")) }}</p>-->
        </div>
        <div class="col-right bg-secondary hover-dimmer" @click="addToInventory('bottom')">
            <div>
                <span class="status-tag" v-show="storeMyDownload.hasNewNotification">!</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                    <path d="M77.7777778,9.77777778 L71.5555556,2.22222222 C70.6666667,0.888888889 68.8888889,0 66.6666667,0 L13.3333333,0 C11.1111111,0 9.33333333,0.888888889 8,2.22222222 L2.22222222,9.77777778 C0.888888889,11.5555556 0,13.3333333 0,15.5555556 L0,71.1111111 C0,76 4,80 8.88888889,80 L71.1111111,80 C76,80 80,76 80,71.1111111 L80,15.5555556 C80,13.3333333 79.1111111,11.5555556 77.7777778,9.77777778 Z M40,64 L15,40 L31,40 L31,28 L49,28 L49,40 L65,40 L40,64 Z M8,10 L13.0793651,4 L66.9206349,4 L72,10 L8,10 Z"></path>
                </svg>
            </div>
            <p class="text-primary" :style="download_btn_style">{{ lang($t("Download")) }}</p>
        </div>
        <ConfirmDialog
            v-model="is_dialog_visible"
            :title="c_title"
            :content="c_content"
            :confirm-url="external_link"
            :show-confirm="show_confirm"
            @confirm="onConfirm"
            :show-cancel="show_cancel"
        />
    </div>
</template>

<script>
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import myDownload from '@/MyDownload';
    import api from '@js/api';
    import {store} from '@store/store';
    import axios from 'axios';
    import ConfirmDialog from "./ConfirmDialog.vue";
    import prihum_api from "../special_websites/prihum/api";
    import {URI} from "../../config/uri";

    export default {
        name: "SubCateFooter",
        mixins:[common,storeMapper],
        components: {
            ConfirmDialog,
            'my-download': myDownload
        },
        props: {
            show_batch_btn_goodnotes: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                total_size_style: {},
                add_to_inventory_style: [],
                total_file_style: {},
                download_btn_style: {},
                allow_to_add: true,
                c_title: "Notice",
                is_dialog_visible: false,
                c_content: "Please select at least one resource that can be shared to Goodnotes to proceed with batch sync.",
                external_link: '',
                show_confirm: true,
                show_cancel: false,
            }
        },
        computed: {
            resource_total_select() {
               // return store.getters("resource_store/total_select");
                //return  this.subcate_total_select + this.my_download_total_select;
                return this.storeMyDownload.total_select + this.storeResource.subcate_total_select;
            },
            resource_total_size() {
                let total_size = this.storeResource.subcate_total_size + this.storeMyDownload.total_size;

                if (this.storeResource.subcate_total_select === 0 || total_size > 524288000) {
                    this.total_size_style = {"color": "red"};
                    this.download_btn_style = {"color": "#a3a3a3"};
                    this.allow_to_add = false;
                }

                if (this.resource_total_select >  200) {
                    this.total_file_style = {"color": "red"};
                    this.download_btn_style = {"color": "#a3a3a3"};
                    this.allow_to_add = false;

                }

                if (total_size > 524288000 || this.resource_total_select >  200) {
                    this.add_to_inventory_style = ['dim'];
                    this.allow_to_add = false;

                } else {
                    this.total_size_style = {};
                    this.add_to_inventory_style = [];
                    this.total_file_style = {};
                    this.download_btn_style = {};
                    this.allow_to_add = true;

                }
                return this.formatSize(total_size);
            }
        },
        watch: {
            resource_total_select: function (newValue, oldValue) {
            },
            resource_total_size: function (newValue, oldValue) {
            }
        },
        mounted() {
            this.listenEvents();
        },
        methods: {
            listenEvents() {
                let self = this;

                EventBus.$on("add_to_inventory", (value)=>{
                    self.addToInventory(value);
                });
            },
            addToInventory(value) {

                let self = this;
                var total_size = this.storeMyDownload.total_size;
                var subcate_total_size = this.storeResource.subcate_total_size;
                let add_resource = true;
                let show_popup = true;

                if (total_size > 524288000 || this.resource_total_select >  200 || !self.allow_to_add) {
                    add_resource = false;
                    show_popup = false;
                }

                if (subcate_total_size <= 0) {
                    add_resource = false;
                    show_popup = true;
                }

                if (add_resource) {
                    var obj_resource = Object.assign({}, this.storeResource.subcate_resource_list);
                    EventBus.$emit("showGlobalLoading");

                    //ajax call to save selected resource to db
                    api.saveResourceToMyDownload(obj_resource).then(resp=> {

                        //show 紅色的!在my download
                        // this.$store.commit("my_download_store/newNotification");
                        //update my download page resource data
                        this.$store.commit("my_download_store/updateData", resp.data);

                        //show 綠色的圓點在my download的resource list 上
                        this.$store.commit("resource_store/update_new_resource", this.storeResource.select_num_of_new_resource);

                        this.$store.commit("resource_store/clear_sub_cate");

                        EventBus.$emit('unselect_all_subcate');
                        EventBus.$emit('unselect_select_all_btn');
                        EventBus.$emit('unselect_all_research');
                        EventBus.$emit("showMyDownload", value);

                        this.$store.commit("resource_store/update_check_all_status", false);
                        EventBus.$emit("hideGlobalLoading");

                    })
                        .catch(function (resp) {
                            EventBus.$emit("hideGlobalLoading");

                        });
                } else {
                    if (show_popup) {
                        self.showMyDownloadAction(value);
                    }
                }



            },
            /**
             *
             * @param value top / bottom
             */
            showMyDownloadAction: function(value) {

                Promise.all(
                    [
                        api.getDownloadData()
                    ]
                    .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseDownloadData) => {

                        if (responseDownloadData) {
                            this.$store.commit("my_download_store/updateData", responseDownloadData.data);
                        }

                            this.$store.commit("my_download_store/offNotification");
                            this.$store.commit("resource_store/update_new_resource", 0);
                            EventBus.$emit("showMyDownload", value);

                        })
                    ).catch(function (resp) {

                    });

            },
            addToPendingShareGoodNotes() {
                const cat_list = Array.isArray(this.storeResource.cate_list)
                    ? this.storeResource.cate_list
                    : null;

                if (!cat_list || cat_list.length === 0 || cat_list.every(item => !Array.isArray(item.resource) || item.resource.length === 0)) {
                    this.is_dialog_visible = true;
                    return;
                }
                const extract_metadata_ids = (data) => {
                    const meta_data_ids = [];

                    data.forEach(category => {
                        category.resource.forEach(resource => {
                            const has_goodnotes = resource.content.some(item =>
                                typeof item.value === 'string' && item.value.includes(URI.OPEN_GOODNOTES)
                            );

                            if (has_goodnotes && resource.check) {
                                meta_data_ids.push(this.getResourceId(resource.metadata_id));
                            }
                        });
                    });

                    return meta_data_ids;
                }

                const result = extract_metadata_ids(cat_list);

                if (result.length === 0) {
                    this.is_dialog_visible = true;
                    return;
                } else {
                    this.is_dialog_visible = true;
                    this.show_confirm = false;
                    this.show_cancel = true;
                    this.c_content = "You are about to be redirected to Goodnotes. Do you want to proceed?";
                }

                EventBus.$emit("showGlobalLoading");
                this.external_link = prihum_api.syncToGoodNotes(result);

                EventBus.$emit("hideGlobalLoading");
            },
            onConfirm() {
                // close dialog
                this.is_dialog_visible = false;
            }
        }

    }

</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .foot-panel {
        @extend %border-tertiary-top;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3.5rem;
        display: inline-flex;
        z-index: 50;
        -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
        box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.15);
        align-items: center;
    }

    .foot-panel .col-left {
        flex-grow: 1;
        height: 100%;
        padding: 0.75rem 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .foot-panel .col-left>p {
        font-size: 0.875rem;
        text-align: left;
        padding-right: 1.5rem;

    }

    .foot-panel .col-left>a {
        display:flex;
    }

    .foot-panel .col-right {
        @extend %border-tertiary-left;
        flex-grow: 0;
        height: 100%;
        cursor: pointer;
        padding: 0 1.5rem;
        border-left: 1px solid #b4cce5;
        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;

        &:hover {
            @extend %hover-dimmer;
        }
    }

    .foot-panel .col-right p {
        font-size: 0.875rem;
        margin-left: 0.75rem;
        text-align: left;
        font-weight: 500;
        float: left;
        line-height: 3.5rem;
    }

    .foot-panel .col-right>div {
        margin: 1.125rem 0;
        float: left;
        width: 1.25rem;
        height: 1.25rem;
        position: relative;
    }

    .foot-panel .col-right svg {
        @extend %fill-primary;
    }

    .foot-panel .status-tag {
        position: absolute;
        left: -0.75rem;
        top: -0.75rem;
    }

    @include narrow {
        .foot-panel .col-right p {
            display: none;
        }

        .foot-panel .col-left {
            display:flex;
            padding: 0.75rem 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SubCateFooter.vue